import { breadcrumbsIntegration, httpClientIntegration, init, makeBrowserOfflineTransport, makeFetchTransport } from '@sentry/angular';
import { Integration } from '@sentry/core';

export abstract class WarehouseWorker {
  initSentry(environment: any): void {
    const integrations: Integration[] = [httpClientIntegration({ failedRequestStatusCodes: [[400, 599], 0] })];
    if (environment.name !== 'production') {
      integrations.push(breadcrumbsIntegration({ console: false }));
    }
    init({
      dsn: 'https://567148f1745f4f589e65d2d72b133f18@o509349.ingest.sentry.io/5603863',
      environment: environment.name,
      tracesSampleRate: 1,
      integrations,
      release: `damofire@${environment.version}`,
      denyUrls: [/localhost:4002\//i],
      normalizeDepth: 10,
      transport: makeBrowserOfflineTransport(makeFetchTransport),
      tracePropagationTargets: [environment.appConfig.fns],
      beforeSend(event, hint) {
        const exception = hint.originalException || (event?.extra?.err as Error) || event?.message;
        if (isBannedError(exception)) {
          return null;
        }
        return event;
      },
    });
  }
}

export const isBannedError = (error: string | Error | unknown): boolean => {
  const errorsToIgnore = ['INTERNAL ASSERTION FAILED', 'network-request-failed'];
  let errorMessage: string;
  if (!error) {
    return false;
  }

  if (typeof error === 'string') {
    errorMessage = error;
  } else if (typeof error === 'object' && 'message' in error) {
    errorMessage = (error as Error).message;
  } else {
    return false;
  }

  for (const errorToIgnore of errorsToIgnore) {
    if (errorMessage && errorMessage.includes(errorToIgnore)) {
      return true;
    }
  }
  return false;
};
